import { render, staticRenderFns } from "./RollingAvatarFx.vue?vue&type=template&id=01b47f2b&scoped=true"
import script from "./RollingAvatarFx.vue?vue&type=script&lang=js"
export * from "./RollingAvatarFx.vue?vue&type=script&lang=js"
import style0 from "./RollingAvatarFx.vue?vue&type=style&index=0&id=01b47f2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b47f2b",
  null
  
)

export default component.exports